import { render, staticRenderFns } from "./AllowedDomains.vue?vue&type=template&id=dcd19094&"
import script from "./AllowedDomains.vue?vue&type=script&lang=js&"
export * from "./AllowedDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports